export default __webpack_public_path__ + "static/media/ebook.93c115b8.png";